var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{key:_vm.color,staticClass:"color-dot",class:{ 'is-selected': _vm.selected },style:({ backgroundColor: _vm.color })})
}
var staticRenderFns = []

export { render, staticRenderFns }